import states from '@zillow/state-names';
export var DEFAULT_SOURCE = 'OMHDP';
/**
 * Submit contact to Zatlas as a lead
 * @param name from form
 * @param email from form
 * @param phone from form
 * @param property contacted from
 * @param zatlasEndpoint For POST request, should have trailing slash
 */

var submitContact = function submitContact(_ref) {
  return new Promise(function ($return, $error) {
    var _property$zillowOffer, property, name, email, phone, zatlasEndpoint, source, stateName, postData, response;

    property = _ref.property, name = _ref.name, email = _ref.email, phone = _ref.phone, zatlasEndpoint = _ref.zatlasEndpoint, source = _ref.source;

    if (!zatlasEndpoint) {
      return $error(new Error('zatlasEndpoint must be defined'));
    }

    stateName = states[property.state];
    postData = {
      lead: {
        sender: {
          name: name,
          phone: phone,
          email: email
        },
        property: {
          zpid: property.zpid,
          address: property.streetAddress,
          city: property.city,
          state: stateName,
          zipCode: property.zipcode,
          homeStatus: property.homeStatus,
          market: (_property$zillowOffer = property.zillowOfferMarket) === null || _property$zillowOffer === void 0 ? void 0 : _property$zillowOffer.name
        },
        brand: 'Zillow',
        source: source || DEFAULT_SOURCE,
        type: source !== null && source !== void 0 && source.toUpperCase().includes('SEBCMA') ? 'SELLER' : 'OOBB' // OOBB stands for OutOfBuyBox, usage refers to API in zatlas-service

      }
    };

    var $Try_1_Post = function () {
      try {
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    var $Try_1_Catch = function (error) {
      try {
        return $return({
          errors: {
            submit: 'Something went wrong. Please try again later'
          }
        });
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    try {
      return Promise.resolve(fetch(zatlasEndpoint + "zatlas-lead-cors", {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json'
        }
      })).then(function ($await_2) {
        try {
          response = $await_2;

          if (!response.ok) {
            return $return({
              errors: {
                submit: 'Something went wrong. Please try again later'
              }
            });
          }

          return $return({
            success: true
          });
        } catch ($boundEx) {
          return $Try_1_Catch($boundEx);
        }
      }, $Try_1_Catch);
    } catch (error) {
      $Try_1_Catch(error)
    }
  });
};

export default submitContact;
//# sourceMappingURL=submitContact.js.map